import { useRef, useState, type FormEvent } from "react";

export default function NewsletterSignup() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const formRef = useRef<HTMLFormElement>(null);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = (data.get("website_alt") as string) || "";
    if (honeypot.trim().length > 0) {
      setStatus("success");
      form.reset();
      return;
    }
    data.delete("website_alt");
    const email = (data.get("email") as string) || "";
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setErrorMsg("請輸入有效的電子郵件地址");
      return;
    }
    setStatus("loading");
    try {
      const params = new URLSearchParams();
      data.forEach((v, k) => params.append(k, String(v)));
      const res = await fetch("https://readdy.ai/api/form/dahsno3p14a1h3mr6rt0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam = /spam/i.test(serverMsg) || /spam/i.test(text);
      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setErrorMsg(serverMsg || "訂閱失敗，請稍後再試");
      }
    } catch {
      setStatus("error");
      setErrorMsg("網路錯誤，請稍後再試");
    }
  };

  return (
    <section id="newsletter" className="py-16 md:py-20 bg-brand-50/60">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-block px-6 py-2 rounded-md bg-brand-600 text-white text-lg tracking-wider">訂閱更新</div>
        <h2 className="mt-5 font-serif text-3xl md:text-4xl text-brand-800">接收最新療程與護膚資訊</h2>
        <p className="mt-4 text-brand-700/70 text-sm md:text-base max-w-xl mx-auto">
          訂閱我們的通訊，定期收取新療程、護膚貼士與會員優惠資訊，隨時掌握美業大健康最新動向。
        </p>

        <form
          id="newsletter-form"
          ref={formRef}
          onSubmit={onSubmit}
          data-readdy-form
          className="mt-8 max-w-xl mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-honeypot"
          />

          <div className="flex flex-col sm:flex-row gap-3">
            <input
              id="newsletter-email"
              type="email"
              name="email"
              required
              placeholder="你的電郵地址"
              className="flex-1 rounded-md border border-brand-200 bg-white px-4 py-3 text-sm focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-brand-600 hover:bg-brand-700 text-white text-sm whitespace-nowrap cursor-pointer transition disabled:opacity-60"
            >
              {status === "loading" ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i> 訂閱中...
                </>
              ) : (
                <>
                  訂閱 <i className="ri-mail-send-line"></i>
                </>
              )}
            </button>
          </div>

          {status === "success" && (
            <p className="mt-3 text-sm text-brand-600">訂閱成功！感謝你關注 ISHB。</p>
          )}
          {status === "error" && (
            <p className="mt-3 text-sm text-rose-500">{errorMsg}</p>
          )}
        </form>
      </div>
    </section>
  );
}